import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import ProfilService from "../../context/ProfilService";
import AuthService from "./Service";
import { useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { toast } from "sonner";
import { buildLoginUrlFromLocation } from "../../lib/authRedirect";

export const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { user, setUser, isLoaded, setIsLoaded } = useUser();
  const [isAuth, setIsAuth] = useState(null);
  // const [firstConnexion, setFirstConnexion] = useState(null);
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    // Si user n'est pas chargé, on le fetch
    if (!isLoaded) {
      ProfilService.getMyInfo()
        .then((response) => {
          setUser(response.data);
        })
        .catch(() => {
          setUser(null);
        })
        .finally(() => {
          setIsLoaded(true);
        });
      return;
    }
    // Quand user est chargé, on vérifie l'auth
    if (isLoaded) {
      if (user) {
        AuthService.getAuth()
          .then((response) => {
            setIsAuth(true);
            // setFirstConnexion(response.first_connexion);
          })
          .catch(() => {
            setIsAuth(false);
            toast.error("Votre session a expiré. Veuillez vous reconnecter.");
          })
          .finally(() => {
            setIsVerifying(false);
          });
      } else {
        setIsAuth(false);
        setIsVerifying(false);
      }
    }
  }, [user, isLoaded, setUser, setIsLoaded]);

  if (!isLoaded || isVerifying || isAuth === null) {
    return null; // Show a loader or nothing while waiting for user info
  }

  if (!isAuth) {
    return (
      <Navigate
        to={buildLoginUrlFromLocation(location)}
        replace
        state={{ from: location }}
      />
    );
  }

  // if (firstConnexion === true && location.pathname !== RouterPath.FIRST_CONNEXION) {
  //   return <Navigate to={RouterPath.FIRST_CONNEXION} />;
  // }

  return children;
};